<template>
  <div>
    <background>
      <template #g>
        <foreignObject v-for="(animation, index) in animations"
                       :key="'svg_'+index"
                       v-bind="animation.svg">
          <!-- mouseover/mousleave have been commented out, because the animations overlap.
          In those circumstances we cannot determine which animation has been hovered. The effect is that
          sometimes the wrong tooltip would be displayed...!
            @mouseover.native="hoverIndex = index"
            @mouseleave.native="hoverIndex = -1"
          -->
          <fin-lottie-switch
            :animate="selectedIndex === index || hoverIndex === index"
            :options="{animationData: animation.animationData, autoplay: false}"/>
        </foreignObject>
      </template>

      <template>
        <fin-step-by-step-button
          :active="value===index"
          :hovered="hoverIndex === index"
          :key="'btn_'+index"
          :tooltipText="tooltipTexts[index].tooltip.text"
          :style="animation.buttonStyle"
          :class="'btn_'+index"
          @click.native.capture.stop="() => {buttonClicked(index)}"
          @mousedown.native.stop="() => {buttonClicked(index)}"
          @touchstart="() => {buttonClicked(index)}"
          @touchstart.native.capture.stop="() => {buttonClicked(index)}"
          @mouseover.native.prevent.stop="() => {hoverIndex = index}"
          @mouseleave.native.stop="() => {hoverIndex = -1}"
          v-for="(animation, index) in animations"
        />
        <span :key="'text_'+index"
              :style="animation.textStyle"
              v-for=" (animation, index) in animations">
          {{ animation.title }}
        </span>

      </template>
    </background>
  </div>
</template>

<script>
import FinStepByStepButton from '@/components/pages/onboarding/Step2/StepByStep/StepByStepBtn/index'
import Background from './Background'
import FinLottieSwitch from "@/components/pages/onboarding/Step2/StepByStep/LottieSwitch/index"

export default {
  name: 'finStepByStep4Illu',
  components: {FinLottieSwitch, FinStepByStepButton, Background},
  props: {
    value: {
      type: Number
    },
    animations: {
      type: Array
    },
    tooltipTexts: {
      type: Array
    }
  },
  data() {
    return {
      hoverIndex: -1,
      selectedIndex: -1
    }
  },
  methods: {
    buttonClicked(index) {
      this.$emit('input', index)
      this.selectedIndex = index
    }
  }
}
</script>

<style scoped>

</style>
